import { dataFetcher } from 'core/services/requestHandler';   

const getVendorList = async (data = {}, config = {}) => {
  return dataFetcher('users/getVendorList', data, {...config});
};

const activateVendor = async (data = {}, config = {}) => {
  return dataFetcher('users/activateVendor', data, {...config});
};

const deactivateVendor = async (data = {}, config = {}) => {
  return dataFetcher('users/deactivateVendor', data, {...config});
};

const updateVendorDetails = async (data = {}, config = {}) => {
  return dataFetcher('users/updateVendorDetails', data, {method: 'POST', ...config});
};

const getVendorDetails = async (data = {}, config = {}, path = {}) => {
  const { vendorId } = path;
  return dataFetcher(`/users/vendor/${vendorId} `, data, {...config});
};

const getVendorListWithActivityStatus = async (data = {}, config = {}) => {
  const {state} = data
  return dataFetcher('users/getVendorListWithActivityStatus/'+state, {}, {...config});
};

export { getVendorList, activateVendor, deactivateVendor, updateVendorDetails, getVendorDetails, getVendorListWithActivityStatus };
